import * as React from 'react';
import { clsx } from 'clsx';
import { TColors } from '@cian/ui-kit';

import * as styles from './IconStreetCar16.css';

interface IIconStreetCar16Props {
  color?: TColors;
}

// TODO: Заменить на китовую иконку в CD-170476
export const IconStreetCar16: React.FC<IIconStreetCar16Props> = ({ color }) => {
  return <div className={clsx(styles['icon'], color === 'white_100' && styles['white'])} />;
};
